import React, { useState, useEffect } from "react";
import "./Products.css";
import { toast } from "react-toastify";
import axiosConfig from "../../Service/axiosConfig";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { addProduct, removeProduct, addWishlist, removeWishlist } from "../../redux/Slices/cartSlice";
import { useSelector, useDispatch } from "react-redux";
import { MdAdd, MdRemove } from "react-icons/md";
import { TfiTimer } from "react-icons/tfi";
import { FiShoppingCart, FiHeart } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import { NavLink, useParams } from "react-router-dom";
import { AccessDeny, LocationModal } from "../PopupModal";
import { LoginModal as WishlistLoginModal } from "../LoginModal/LoginModal";
import { selectCartTotal } from "../../redux/Slices/cartSlice";
import { buildSeoPath } from "../../Utils/routes";

const Product = (props) => {
  const { item, setIsDeleted, LoginAccount, Setlogin, listingType } = props;
  let user = localStorage.getItem("userId");
  const { friendlyurl, categoryurl, subcategoryurl } = useParams();
  const { cart } = useSelector((state) => state);
  const [isWishlist, setIsWishlist] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [NoAccess, setNoAccess] = useState("");
  const [LocationpopupType, setLocationpopupType] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);
  const total = useSelector(selectCartTotal);
  const [showMessage, setShowMessage] = useState(false);
  const [wishlistLoading, setWishlistLoading] = useState(false);
  const [loginShow, setLoginShow] = useState(false);
  const [charges, setCharges] = useState({
    delivery_charges: 0,
    packing_charges: 0,
  });
  const Navigate = useNavigate();
  const handleResize = () => {
    setIsMobile(window.innerWidth < 1020);
  };
  const dispatch = useDispatch();
  let Data = [];
  const Handlepopup = () => {
    setLocationpopupType("");
  };
  const showMaxQuantityMessage = () => {
    setShowMessage(true);
    setTimeout(() => {
      setShowMessage(false);
    }, 2000);
  };

  const isRent = typeof item._wishlistType !== "undefined"
    ? item._wishlistType === "rent"
    : typeof listingType !== "undefined"
      ? listingType === "rent"
      : localStorage.getItem("listingType") === "rent";
  const expectedType = isRent ? "rental" : "sale";

  const isWishlisted = (cart?.wishlists || []).some((p) => p.id === item.id && p.type === expectedType);

  const handleWishlist = async (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    const token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId") || localStorage.getItem("userid");

    if (!token || !userId) {
      setLoginShow(true);
      return;
    }

    if (wishlistLoading) return;
    setWishlistLoading(true);

    try {
      if (isWishlisted) {
        const wishItem = (cart?.wishlists || []).find(p => p.id === item.id && p.type === expectedType);
        if (wishItem?.wish_id) {
          await axiosConfig.delete(`/catlog/wishlists/${wishItem.wish_id}/`);
        }
        dispatch(removeWishlist({ productId: item.id, type: expectedType }));
        toast.success("Removed from wishlist");
        if (typeof setIsDeleted === 'function') {
          setIsDeleted(true);
        }
      } else {
        const payload = { user: userId, type: expectedType };
        if (item.product) {
          payload.varient = item.id;
        } else {
          payload.product = item.id;
        }
        const res = await axiosConfig.post(`/catlog/wishlists/`, payload);
        dispatch(addWishlist({
          productId: item.id,
          wish_id: res.data.id,
          type: expectedType
        }));
        toast.success("Added to wishlist");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setWishlistLoading(false);
    }
  };

  const itemPrice = isRent
    ? (item.prices?.rental_price || item.rental_price || item.prices?.sale_price || item.sale_price)
    : (item.prices?.sale_price || item.sale_price);
  const itemOfferPrice = isRent
    ? (item.prices?.rental_offer_price || item.rental_offer_price || itemPrice)
    : (item.prices?.sale_offer_price || item.sale_offer_price);

  const addToCart = () => {
    dispatch(
      addProduct({
        product: {
          id: item.id,
          name: item.name,
          image: item.images?.[0]?.image?.image || "",
          price: itemPrice,
          offer_price: itemOfferPrice || itemPrice,
          weight_in_kg: item.weight_in_kg,
          max_qty: item.max_qty,
          subcategory: item.subcategory,
          speed: item.category,
        },
        quantity: 1,
      })
    );
  };
  const addToCart1 = () => {
    const minQty = item.min_qty || 1;
    dispatch(
      addProduct({
        product: {
          id: item.id,
          name: item.name,
          image: item.images?.[0]?.image?.image || "",
          price: itemPrice,
          offer_price: itemOfferPrice || itemPrice,
          weight_in_kg: item.weight_in_kg,
          max_qty: item.max_qty,
          min_qty: minQty,
          subcategory: item.subcategory,
          speed: item.category,
        },
        quantity: minQty,
      })
    );
    toast.success("Added to cart");
  };
  const removeFromCart = () => {
    // dispatch(removeProduct({ productId: item.id, quantity: 1 }));
    // console.log("Item removed from your cart");
    const currentQuantity = getProductQuantity(item.id,)
    const minQty = item.min_qty || 1;
    if (currentQuantity > minQty) {
      dispatch(removeProduct({ productId: item.id, quantity: 1 }));
      toast.success("Added to cart");
    } else if (currentQuantity === minQty) {
      dispatch(removeProduct({ productId: item.id, quantity: minQty }))
      toast.success("Added to cart");
    }
  };
  const serializedState = JSON.stringify(cart.products);
  // localStorage.setItem('state', serializedState);
  const getProductQuantity = (productId) => {
    const product = cart?.products?.find((p) => p.id === productId);
    return product ? product.quantity : 0;
  };
  const HandleNavigate = (path) => {
    // console.log(path, friendlyurl);
    Navigate(path);
  };
  const productPath = item.product 
    ? `/product/${item.product?.slug || item.slug || item.product_slug || "unknown"}?variant=${item.id}`
    : `/${item.slug || item.product_slug || "unknown"}`;

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // console.log(item);
  const currentQuantity = getProductQuantity(item.id);
  const stock = isRent ? item.rental_stock : item.sale_stock;
  const isOutOfStock =
    item.available === false ||
    item.availability === false ||
    stock === 0;
  const isLowStock = !isOutOfStock && stock > 0 && stock <= 5;
  const badgeLabel = isRent ? "Rent" : "Buy";
  const displayOfferPrice = itemOfferPrice && itemOfferPrice !== itemPrice && itemOfferPrice > 0;

  return (
    <>
      <div className="product-item new-product-card">
        <div
          className="product-img"
          onClick={() => HandleNavigate(productPath)}
          style={{ cursor: "pointer" }}
        >
          <img
            src={item.images?.[0]?.image?.image || item.image.image || ""}
            alt={item?.name}
          />
        </div>

        {localStorage.getItem("site_data") &&
          JSON.parse(localStorage.getItem("site_data")).ecommerce_type !==
          "Conventional" &&
          localStorage.getItem("express_delivery_time") && (
            <div className="timer">
              <TfiTimer size={10} />
              <span>{localStorage.getItem("express_delivery_time")} mins</span>
            </div>
          )}

        <p
          className="name new-product-name"
          onClick={() => HandleNavigate(productPath)}
          style={{ cursor: "pointer" }}
        >
          {item.name}
        </p>

        <div className="listing-badge">{badgeLabel}</div>

        <div className="price-row">
          <span className="current-price">
            ${parseFloat(displayOfferPrice ? itemOfferPrice : itemPrice || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
          {displayOfferPrice && (
            <>
              <span className="original-price">
                ${parseFloat(itemPrice || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
              {(item.discount_percentage > 0 || item.product?.discount_percentage > 0) && (
                <span className="discount-badge">
                  {item.discount_percentage || item.product?.discount_percentage}% OFF
                </span>
              )}
            </>
          )}
        </div>

        {isLowStock && (
          <div style={{ color: "#d97706", fontSize: "12px", fontWeight: "600", marginBottom: "8px" }}>
            Hurry, only {stock} left!
          </div>
        )}

        <div className="pc-actions">
          {isOutOfStock ? (
            <div className="out-of-stock-text" style={{ flex: 1, marginTop: 0, display: "flex", alignItems: "center", color: "#ff0000", fontWeight: "600" }}>Out of stock</div>
          ) : (!isRent && currentQuantity > 0) ? (
            <div style={{ flex: 1, display: "flex", height: "36px", alignItems: "center", border: "1.5px solid #735ceb", borderRadius: "6px", overflow: "hidden", background: "#fff" }}>
              <button
                type="button"
                style={{ width: "40%", height: "100%", background: "#735ceb", color: "#fff", border: "none", fontSize: "18px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                onClick={(e) => { e.stopPropagation(); removeFromCart(); }}
              >
                -
              </button>
              <div style={{ width: "20%", minWidth: "24px", textAlign: "center", fontWeight: "bold", color: "#1a1f36", fontSize: "14px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {currentQuantity}
              </div>
              <button
                type="button"
                style={{ width: "40%", height: "100%", background: "#735ceb", color: "#fff", border: "none", fontSize: "18px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                onClick={(e) => {
                  e.stopPropagation();
                  currentQuantity === item.max_qty
                    ? showMaxQuantityMessage()
                    : addToCart();
                }}
              >
                +
              </button>
            </div>
          ) : (
            <button
              type="button"
              className="pc-btn-add"
              onClick={(e) => {
                e.stopPropagation();
                if (isRent) {
                  HandleNavigate(productPath);
                } else {
                  addToCart1();
                }
              }}
            >
              <FiShoppingCart /> Add to Cart
            </button>
          )}

          <button
            type="button"
            className={`pc-btn-wish${isWishlisted ? " active" : ""}`}
            disabled={wishlistLoading}
            aria-label={isWishlisted ? "Remove from wishlist" : "Add to wishlist"}
            onClick={handleWishlist}
          >
            {isWishlisted ? <FaHeart color="#e74c3c" style={{ color: "#e74c3c", fill: "#e74c3c" }} /> : <FiHeart color="currentColor" />}
          </button>
        </div>

        {LocationpopupType === "success" && (
          <LocationModal
            LocationpopupType={LocationpopupType}
            setLocationpopupType={setLocationpopupType}
          />
        )}

        {NoAccess === "success" && (
          <AccessDeny NoAccess={NoAccess} setNoAccess={setNoAccess} />
        )}
      </div>
      {loginShow && (
        <div onClick={(e) => e.stopPropagation()}>
          <WishlistLoginModal setLoginType={setLoginShow} LoginType={loginShow} setLoggedIn={Setlogin} LoggedIn={LoginAccount} />
        </div>
      )}
      {showMessage && (
        <div
          className="custom-message"
          style={{ position: "absolute", top: "77%" }}
        >
          Sorry,you are reached maximum quantity.
        </div>
      )}
    </>
  );
};
export default Product;
